// Modal Image Gallery
export function closeModal() {

  document.getElementById("modal01").style.display = "none";
}

